import React, { useEffect, useRef, useState } from 'react';
import SearchIcon from '../../../../img/search-icon.svg';

type Categoria = { value: string; label: string };

interface ModalSelecionarCategoriasProps {
  selected?: string[];
  onClose: () => void;
  onSelect: (categorias: string[]) => void;
  categorias?: Categoria[];
}

const CATEGORIAS_PADRAO: Categoria[] = [
  { value: 'PASSEIO',   label: 'Passeio' },
  { value: 'APLICATIVO DE MOBILIDADE URBANA',label: 'Aplicativo de Mobilidade Urbana' },
  { value: 'TAXI',      label: 'Taxi' },
  { value: 'MOTO RISCO',  label: 'Moto Risco' },
  { value: 'MOTOCICLETA',    label: 'Motocicleta' },
  { value: 'MOTOS ESPECIAIS',       label: 'Motos Especiais' },
  { value: 'MOTO APP',   label: 'Moto App' },
  { value: 'DIESEL LEVE',label: 'Diesel Leve' },
  { value: 'DIESEL LEVE - ROUBO E FURTO',      label: 'Diesel Leve - Roubo e Furto' },
  { value: 'AUTOMOVEL - ROUBO E FURTO',  label: 'Automóvel - Roubo e Furto' },
  { value: 'UTILITARIO',    label: 'Utilitário' },
  { value: 'CAMINHAO',       label: 'Caminhão' },
  { value: 'DIVERSOS',  label: 'Diversos' },
];

const ModalSelecionarCategorias: React.FC<ModalSelecionarCategoriasProps> = ({
  selected = [],
  onClose,
  onSelect,
  categorias = CATEGORIAS_PADRAO,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const [selecionadas, setSelecionadas] = useState<string[]>(selected);

  const [search, setSearch] = useState('');
  const categoriasFiltradas = categorias.filter((c) =>
    c.label.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const toggleCategoria = (value: string) => {
    setSelecionadas([value]);
  };

  const handleConfirm = (e: React.FormEvent) => {
    e.preventDefault();
    onSelect(selecionadas);
  };

  return (
    <div className="add-car-modal-overlay" role="dialog" aria-modal="true" aria-label="Selecionar categorias">
      <div ref={modalRef}>
        <div>
          <form className="LightboxLogin" onSubmit={handleConfirm}>
            <div className="EditarCarro">Selecionar Categorias</div>

            {/* === Topo: Barra de busca + limpar seleção === */}
            <div style={{ paddingTop: 'unset' }} className="Topo">

              <div className="Frame1000003980">
                <div className="Frame1000003983">
                  <div className="ItemSearch">
                    <img
                      className="imgIcon"
                      src={SearchIcon}
                      alt="Buscar"
                      width="20"
                      height="20"
                    />
                  </div>

                  <div
                    style={{ paddingTop: '5px', paddingBottom: '5px', lineHeight: 'unset' }}
                    className="PesquisePorPlacaChassiOuNDoEvento"
                  >
                    <input
                      type="text"
                      className="PesquiseInput"
                      placeholder="Buscar categoria"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="Camada1" />

              <div
                style={{ padding: '10px 10px', borderRadius: '41px' }}
                className="CtaBigEditar cancel"
                onClick={() => setSelecionadas([])}
              >
                <button className="CustomFileCancel" type="button" style={{ cursor: 'pointer' }}>
                  Limpar seleção
                </button>
              </div>
            </div>

            {/* === Lista de categorias === */}
            <div
              className="Frame1000004010"
              style={{
                gap: '1rem',
                maxHeight: 300,
                overflowY: 'auto',
                width: '100%',
                maxWidth: 500,
              }}
            >
              {categoriasFiltradas.map(({ value, label }) => (
                <div className="Checkbox" key={value}>
                  <input
                    className="Checkbox2"
                    type="checkbox"
                    value={value}
                    checked={selecionadas.includes(value)}
                    onChange={() => toggleCategoria(value)}
                    style={{ marginRight: 8 }}
                  />
                  {label}
                </div>
              ))}

              {categoriasFiltradas.length === 0 && (
                <div className="AmpleSoft-Regular" style={{ color: 'var(--tema-texto-3, #777)' }}>
                  Nenhuma categoria encontrada.
                </div>
              )}
            </div>

            {/* === Botões === */}
            <div className="Frame1000003998" style={{ marginTop: '2rem' }}>
              <div className="CtaBigEditar cancel" onClick={onClose}>
                <button className="CustomFileCancel" type="button">Cancelar</button>
              </div>

              <button className="CtaBigEditar save" type="submit">
                Confirmar
              </button>
            </div>

          </form>

        </div>
      </div>
    </div>
  );
};

export default ModalSelecionarCategorias;
